export const enum WebSocketMessageType {
  SIGNED = 'purchase_signed',
  PAID = 'payment_paid',
}
